export default "/assets/images/visa-icon.d77eec68317dcfecdb9d238f295d37be.svg";